import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.857 15.417a1.143 1.143 0 1 0 0-2.286 1.143 1.143 0 0 0 0 2.286ZM12 15.417a1.143 1.143 0 1 0 0-2.286 1.143 1.143 0 0 0 0 2.286Z",
  stroke: "#6B5997",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.577 4.034A4.571 4.571 0 1 0 2.286 8.71M5.143 5.154 6.857 3.44",
  stroke: "#CB2F4D",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.429 10.857V9.714H5.714A2.286 2.286 0 0 0 3.43 12v2.286M15.429 14.274V8.56a1.143 1.143 0 0 0-1.143-1.143H8.572A1.143 1.143 0 0 0 7.429 8.56v2.286",
  stroke: "#6B5997",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }